import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { DocumentoAllegato } from '../../models/documento-allegato';

@Component({
  selector: 'app-view-document-dialog',
  templateUrl: './view-document-dialog.component.html',
  styleUrls: ['./view-document-dialog.component.css']
})
export class ViewDocumentDialogComponent implements OnInit {

  idDocument: any;
  src: any = null;
  hasValue: boolean = false;

  constructor(
    private dialogConfig: DialogConfig,
    private helpersService: HelpersService,
    private domSanitizer: DomSanitizer
  ){

  }

  ngOnInit(){
    this.idDocument = this.dialogConfig.data.document;
    this.hasValue = this.dialogConfig.data.hasValue || false;
    this.loadDocument();
  }

  loadDocument(){
    if (this.idDocument && this.hasValue) {
      this.src = this.domSanitizer.bypassSecurityTrustResourceUrl(this.idDocument);
    } else if (this.idDocument) {
      this.helpersService.getDocumentoByIdDocumento(this.idDocument).subscribe((res) => {
        if (res) {
          this.src = this.domSanitizer.bypassSecurityTrustResourceUrl(res);
        }
      });
    }
  }

}
